import React from "react";
import { PhicStatusCardProps } from "./cardTypes";

const CAUSE_COLORS = ["#F28E2B", "#E15759", "#76B7B2", "#59A14F", "#EDC948", "#B07AA1", "#FF9DA7", "#FF9D9A", "#F1CE63"];

export const PhicStatusCard: React.FC<PhicStatusCardProps> = ({ causeTypeSummary }) => {
  const grandTotal = causeTypeSummary.reduce((s, c) => s + c.qty, 0);

  const size = 120; const stroke = 18; const r2 = (size - stroke) / 2; const circ2 = 2 * Math.PI * r2;
  const segments = causeTypeSummary.map((ct, i) => ({
    color: CAUSE_COLORS[i % CAUSE_COLORS.length],
    value: ct.qty,
  }));
  let off2 = 0;

  return (
    <div data-testid="phic-status-card" className="phic-card-layout">
      <div data-testid="phic-donut" className="phic-donut-container" style={{ width: `${size}px`, height: `${size}px` }}>
        <svg width={size} height={size}>
          <circle cx={size/2} cy={size/2} r={r2} fill="none" stroke="#f0f3f5" strokeWidth={stroke} />
          {segments.map((it, idx) => {
            const dashLen = grandTotal > 0 ? (it.value / grandTotal) * circ2 : 0;
            const el = <circle key={idx} cx={size/2} cy={size/2} r={r2} fill="none" stroke={it.color} strokeWidth={stroke}
              strokeDasharray={`${dashLen} ${circ2 - dashLen}`} strokeDashoffset={-(off2 - circ2 * 0.25)} />;
            off2 += dashLen;
            return el;
          })}
        </svg>
        <div className="phic-donut-center">
          <div data-testid="phic-donut-total" className="phic-donut-total">{grandTotal}</div>
          <div className="phic-donut-label">Total</div>
        </div>
      </div>
      <div data-testid="phic-type-table" className="phic-table-container">
        <div className="phic-table-grid phic-table-grid-header">
          <div data-testid="phic-type-header-type" className="phic-table-header">Type</div>
          <div data-testid="phic-type-header-qty" className="phic-table-header phic-table-header-right">Qty</div>
          <div data-testid="phic-type-header-closed" className="phic-table-header phic-table-header-right">Closed</div>
          <div data-testid="phic-type-header-open-ack" className="phic-table-header" style={{ textAlign: "center" }}>Open/Ack</div>
        </div>
        <div className="phic-table-body-scroll">
          <div className="phic-table-grid">
            {causeTypeSummary.map((ct, i) => {
              const openAck = ct.open + ct.acknowledged;
              const pareto = grandTotal > 0 ? Math.round((ct.qty / grandTotal) * 100) : 0;
              const closureRate = ct.qty > 0 ? Math.round((ct.closed / ct.qty) * 100) : 0;
              const kebab = ct.cause_type.toLowerCase().replace(/\s+/g, "-");
              return [
                <div key={`${ct.cause_type}-l`} data-testid={`phic-type-row-label-${kebab}`} className="phic-table-cell phic-type-cell">
                  <span className="phic-color-dot" style={{ backgroundColor: CAUSE_COLORS[i % CAUSE_COLORS.length] }} />
                  <span title={ct.cause_type} className="phic-type-name">{ct.cause_type}</span>
                </div>,
                <div key={`${ct.cause_type}-q`} data-testid={`phic-type-row-qty-${kebab}`} className="phic-table-cell phic-qty-cell">
                  {ct.qty} <span className="phic-pareto">({pareto}%)</span>
                </div>,
                <div key={`${ct.cause_type}-c`} data-testid={`phic-type-row-closed-${kebab}`} className="phic-table-cell phic-closed-cell">
                  {closureRate}% <span className="phic-pareto">({ct.closed}/{ct.qty})</span>
                </div>,
                <div key={`${ct.cause_type}-o`} data-testid={`phic-type-row-open-ack-${kebab}`} className="phic-table-cell phic-open-cell" style={{ textAlign: "center", color: openAck > 0 ? "#d13212" : "#1d8102" }}>{openAck}</div>,
              ];
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
